module.exports = __webpack_public_path__ + "static/img/14000269.a1d8115c.png";